import { useContext, useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// Components
//import { useAnalytics } from "./hooks/analytics/useAnalytics";
import { ConferenceContainer as Conference } from "./scenes/conference/ConferenceContainer";
import { ConferencesContainer as Conferences } from "./scenes/conferences/ConferencesContainer";
import Footer from "./components/Footer/FooterContainer";
import Header from "./components/Header/HeaderContainer";
import SideMenu from "./components/SideMenu/SideMenuContainer";
import Video from "./scenes/video/VideoContainer";
import Videos from "./scenes/videos/VideosContainer";

// Context
import { ConferencesContext } from "./context/conferences";
import { TagsContext } from "./context/tags";
import { VideosContext } from "./context/videos";

// CSS
import "./app.scss";
import "./css/modal.scss";

function App() {
    /**
     * useState
     */

    const [
        hasRedirectedToFeaturedConference,
        setHasRedirectedToFeaturedConference,
    ] = useState(false);
    const [headerOffset, setHeaderOffset] = useState(0);
    const [isSideMenuActive, setIsSideMenuActive] = useState(false);

    /**
     * useContext
     */

    const { fetchConferences } = useContext(ConferencesContext);
    const { fetchFilters, fetchTags } = useContext(TagsContext);
    const { fetchVideos } = useContext(VideosContext);

    /**
     * useEffect
     */

    useEffect(() => {
        fetchConferences();
        fetchFilters();
        fetchTags();
        fetchVideos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * End Hooks
     */

    function renderRouteByQueryParam(props) {
        const { history } = props;
        const queryParams = new URLSearchParams(window.location.search);
        const conferenceParam = queryParams.get("conference");
        const scrollParam = queryParams.get("scroll");
        const toParam = queryParams.get("to");
        const videoParam = queryParams.get("video");
        if (conferenceParam) {
            const scrollQuery = scrollParam ? `?scroll=${scrollParam}` : "";
            history.push(`/conferences/${conferenceParam}${scrollQuery}`);
        } else if (videoParam) {
            history.push(`/videos/${videoParam}`);
        } else if (toParam && toParam === "conferences") {
            history.push("/conferences");
        } else if (toParam && toParam === "videos") {
            history.push("/videos");
        } else {
            return (
                <Conferences
                    {...props}
                    hasRedirectedToFeaturedConference={
                        hasRedirectedToFeaturedConference
                    }
                    setHasRedirectedToFeaturedConference={
                        setHasRedirectedToFeaturedConference
                    }
                />
            );
        }
    }

    return (
        <div className="app" style={{ paddingTop: `${headerOffset}px` }}>
            <Router>
                <SideMenu
                    isSideMenuActive={isSideMenuActive}
                    setIsSideMenuActive={setIsSideMenuActive}
                />
                <Header
                    setHeaderOffset={setHeaderOffset}
                    setIsSideMenuActive={setIsSideMenuActive}
                />
                <Switch>
                    <Route
                        path="/conferences/:id"
                        render={(props) => <Conference {...props} />}
                    />
                    <Route
                        path="/conferences"
                        render={(props) => (
                            <Conferences
                                {...props}
                                hasRedirectedToFeaturedConference={
                                    hasRedirectedToFeaturedConference
                                }
                                setHasRedirectedToFeaturedConference={
                                    setHasRedirectedToFeaturedConference
                                }
                            />
                        )}
                    />
                    <Route
                        path="/register/confirmation"
                        render={(props) => (
                            <Videos {...props} showConfirmationModal />
                        )}
                    />
                    <Route
                        path="/videos/:id"
                        render={(props) => <Video {...props} />}
                    />
                    <Route
                        path="/videos"
                        render={(props) => <Videos {...props} />}
                    />
                    <Route
                        path="/"
                        render={(props) => renderRouteByQueryParam(props)}
                    />
                </Switch>
                <Footer />
            </Router>
        </div>
    );
}

export default App;
